import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { MenuSuperiorContent } from './MenuSuperior';
import { layoutSuperior } from './layoutSuperior';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [MenuSuperiorContent, layoutSuperior],
});
